module.exports = __webpack_public_path__ + "static/img/sspg_04.7d9b308.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sspg/sspg_04.jpg
// module id = KazX
// module chunks = 1